import { useState } from 'react';

type UseToggleListResult = {
  get: (key: string | number) => boolean;
  toggle: (key: string | number) => void;
};

type ToggleData = {
  [key: string | number]: boolean;
};

const useToggleList = (defaultValue: boolean): UseToggleListResult => {
  const [data, setData] = useState({} as ToggleData);
  const toggle = (key: string | number): void => {
    if (key in data) {
      setData({
        ...data,
        [key]: !data[key],
      });
    } else {
      setData({
        ...data,
        [key]: !defaultValue,
      });
    }
  };
  const get = (key: string | number): boolean => {
    if (key in data) {
      return data[key];
    } else {
      return defaultValue;
    }
  };

  return { get, toggle };
};

export default useToggleList;
